import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'
import { InputField, AutoCompleteField } from 'src/components/shared/ui/form/fields'
import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import AddressForm from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/forms/AddressForm'
import {
  checkTipoPersonaFisica,
  getLabelByTipoPersona
} from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/types'
import { FormField } from 'src/enums/Form'
import {
  useGetTipoPersona,
  useGetTipoDocumentoRLByTipoPersona
} from 'src/hooks/fetch/useCatalogoGeneralFilters'
import { TipoPersona } from 'src/interfaces/Catalog'
import { RepresentanteLegal } from 'src/interfaces/EscritosLegales'

function GetFieldsByTipoPersona() {
  const { values } = useFormikContext<RepresentanteLegal>()
  const tipoPersona = values[FormField.INTERVINIENTE_PERSONA_TIPO] as TipoPersona
  const label = getLabelByTipoPersona(tipoPersona)

  if (checkTipoPersonaFisica(tipoPersona)) {
    return (
      <Grid item xs={12} sm={6}>
        <InputField id={FormField.INTERVINIENTE_NOMBRE} label={label} required maxLength={200} />
      </Grid>
    )
  }
  return (
    <>
      <Grid item xs={12} sm={12}>
        <InputField id={FormField.INTERVINIENTE_NOMBRE} label={label} required maxLength={50} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField
          id={FormField.INTERVINIENTE_PRIMER_APELLIDO}
          label={t('form.field.primer_apellido')}
          required
          maxLength={100}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField
          id={FormField.INTERVINIENTE_SEGUNDO_APELLIDO}
          label={t('form.field.segundo_apellido')}
          maxLength={50}
        />
      </Grid>
    </>
  )
}

export default function RepresentanteLegalFormFields(): JSX.Element {
  const { values, setFieldValue, validateForm } = useFormikContext<RepresentanteLegal>()
  const tipoPersona = values[FormField.INTERVINIENTE_PERSONA_TIPO] as TipoPersona
  const tipoPersonaData = useGetTipoPersona(FormField.INTERVINIENTE_PERSONA_TIPO)
  const identificacionTipoData = useGetTipoDocumentoRLByTipoPersona(
    FormField.INTERVINIENTE_IDENTIFICACION_TIPO,
    tipoPersona
  )

  function handleOnChange() {
    if (tipoPersona?.codigo !== '001') {
      setFieldValue(FormField.INTERVINIENTE_IDENTIFICACION_TIPO, null, false)
      setFieldValue(FormField.INTERVINIENTE_IDENTIFICACION, '', false)
      setFieldValue(FormField.INTERVINIENTE_NOMBRE, '', false)
      setFieldValue(FormField.INTERVINIENTE_PRIMER_APELLIDO, '', false)
      setFieldValue(FormField.INTERVINIENTE_SEGUNDO_APELLIDO, '', false)
    } else {
      setFieldValue(FormField.INTERVINIENTE_NOMBRE, '', false)
      setFieldValue(FormField.INTERVINIENTE_IDENTIFICACION_TIPO, null, false)
      setFieldValue(FormField.INTERVINIENTE_IDENTIFICACION, '', false)
    }
    setTimeout(() => validateForm)
  }

  return (
    <>
      <FieldsetGroup legend={t('form.legend.datos_representante_legal')}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <AutoCompleteField
              id={FormField.INTERVINIENTE_PERSONA_TIPO}
              label={t('form.field.tipo_persona')}
              items={tipoPersonaData}
              itemName="descripcion"
              onChange={handleOnChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoCompleteField
              id={FormField.INTERVINIENTE_IDENTIFICACION_TIPO}
              label={t('form.field.tipo_identificacion')}
              items={identificacionTipoData}
              disabled={!tipoPersona}
              itemName="descripcion"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputField
              id={FormField.INTERVINIENTE_IDENTIFICACION}
              label={t('form.field.numero')}
              required
              maxLength={12}
            />
          </Grid>
          <GetFieldsByTipoPersona />
        </Grid>
      </FieldsetGroup>
      <FieldsetGroup legend={t('form.legend.direccion_representante_legal')}>
        <AddressForm />
      </FieldsetGroup>
    </>
  )
}
